export default "__VITE_ASSET__aSCwx7fA__"